import { render, staticRenderFns } from "./FieldsBox.vue?vue&type=template&id=b9304962"
import script from "./FieldsBox.vue?vue&type=script&lang=js"
export * from "./FieldsBox.vue?vue&type=script&lang=js"
import style0 from "./FieldsBox.vue?vue&type=style&index=0&id=b9304962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports